import { I18nService } from '../utils/i18n.service';
import { Directive, HostListener, Input, inject } from '@angular/core';

/** Prepends locale to relative hrefs in anchor tags */
@Directive({
	// eslint-disable-next-line @angular-eslint/directive-selector
	selector: '[href]',
	standalone: false,
})
export class LinkRewriteDirective {
	private readonly i18n = inject(I18nService);

	@Input({ required: true }) readonly href!: string;

	/** Prepends locale to relative hrefs in anchor tags */
	@HostListener('click', ['$event'])
	rewrite(event: MouseEvent): void {
		if (this.isMailtoLink()) return;
		event.preventDefault();
		const href = location.hostname === 'localhost' ? this.href : this.formatHref();

		const target = (event.target as HTMLAnchorElement).target || '_self';

		window.open(href, target);
	}

	/** Returns href with locale prepended if it's a relative url */
	formatHref(): string {
		if (this.isAbsoluteUrl()) return this.href;
		const href = this.href.startsWith('/') ? this.href : `/${this.href}`;
		return `/${this.i18n.locale}${href}`;
	}

	/** Returns true if href is an absolute url */
	private isAbsoluteUrl(): boolean {
		return /^(?:https?:\/\/|\/\/)/i.test(this.href);
	}

	/** Returns true if href is a mailto link */
	private isMailtoLink(): boolean {
		return /^mailto/i.test(this.href);
	}
}
